import { useState } from 'react';
import { Sun, Pause, Play } from 'lucide-react';

export const EditorialMarquee = () => {
  const [paused, setPaused] = useState(false);
  return (
    <div className={`editorial-marquee ${paused ? 'is-paused' : ''}`} data-testid="editorial-marquee">
      <span className="sr-only">Less footprint. More future. Own the best.</span>
      <div className="marquee-track" aria-hidden="true">
        {[0, 1].map((i) => <div className="marquee-content" key={i}><span>LESS FOOTPRINT.</span><Sun /><span className="marquee-outline">MORE FUTURE.</span><Sun /><span>OWN THE BEST.</span><Sun /></div>)}
      </div>
      <button onClick={() => setPaused(!paused)} className="marquee-pause" data-testid="marquee-pause" aria-label={paused ? 'Play moving text' : 'Pause moving text'} aria-pressed={paused}>{paused ? <Play size={14} /> : <Pause size={14} />}</button>
    </div>
  );
};